module.exports = __webpack_public_path__ + "static/media/bg.dca9c2de.jpg";